import { useMemo } from "react";

import { useSalesBreakdownConfigs } from "@components/data/sales-breakdown-configs";
import {
  makeBreakdownDimension,
  makeDateDimension,
} from "@features/sales-v4/dimensions";

export const useBreakdownDimensions = () => {
  const { value: breakdowns } = useSalesBreakdownConfigs();

  return useMemo(() => {
    const dimensions = [makeDateDimension()];

    for (const breakdown of breakdowns) {
      dimensions.push(makeBreakdownDimension(breakdown.name));
    }

    return dimensions;
  }, [breakdowns]);
};
